import React, { useState } from "react";
import axios from "../../../../utills/api";

import {
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Button,
    Label,
    Input,
    Container,
} from "reactstrap";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { toast } from "react-toastify";

const statementCards = [

    {
        title: "Room Statement",
        type: "rooms",
        icon: "ri-hotel-bed-line",
        color: "primary"
    },

    {
        title: "Restaurant Statement",
        type: "restaurant",
        icon: "ri-restaurant-line",
        color: "success"
    },

    {
        title: "Room Service",
        type: "food",
        icon: "ri-service-line",
        color: "warning"
    },

    {
        title: "Spa Statement",
        type: "spa",
        icon: "ri-heart-pulse-line",
        color: "danger"
    },

    {
        title: "Complete Statement",
        type: "all",
        icon: "ri-file-chart-line",
        color: "info"
    }

];

const StatementDownload = () => {

    const today = new Date().toISOString().split("T")[0];

    const firstDay = new Date();

    firstDay.setDate(1);

    const [fromDate, setFromDate] = useState(
        firstDay.toISOString().split("T")[0]
    );

    const [toDate, setToDate] = useState(today);

    const [loading, setLoading] = useState("");

    //------------------------------------------------

    const downloadPDF = async (type) => {

        try {

            setLoading(type);

            const response = await axios.get(

                `/statements/download?type=${type}&from=${fromDate}&to=${toDate}`,

                {
                    responseType: "blob"
                }

            );

            const url = window.URL.createObjectURL(
                new Blob([response.data])
            );

            const link = document.createElement("a");

            link.href = url;

            link.download = `${type}-statement.pdf`;

            document.body.appendChild(link);

            link.click();

            link.remove();

            toast.success("Statement Downloaded");

        } catch (err) {

            console.log(err);

            toast.error("Unable to download statement");

        } finally {

            setLoading("");

        }

    };

    //------------------------------------------------

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb
                        title="Reports & Statements"
                        pageTitle="Reports"
                    />

                    <Row>

                        <Col lg={12}>

                            <Card>

                                <CardHeader>

                                    <h4 className="card-title">

                                        Download Financial Statements

                                    </h4>

                                </CardHeader>

                                <CardBody>

                                    <Row>

                                        <Col md={4}>

                                            <Label>

                                                From Date

                                            </Label>

                                            <Input
                                                type="date"
                                                value={fromDate}
                                                onChange={(e) =>
                                                    setFromDate(e.target.value)
                                                }
                                            />

                                        </Col>

                                        <Col md={4}>

                                            <Label>

                                                To Date

                                            </Label>

                                            <Input
                                                type="date"
                                                value={toDate}
                                                onChange={(e) =>
                                                    setToDate(e.target.value)
                                                }
                                            />

                                        </Col>

                                    </Row>

                                    <Row className="mt-4">

                                        {

                                            statementCards.map(card => (

                                                <Col
                                                    lg={4}
                                                    md={6}
                                                    key={card.type}
                                                    className="mb-4"
                                                >

                                                    <Card
                                                        className="border-0 shadow-sm h-100"
                                                    >

                                                        <CardBody>

                                                            <div className="d-flex">

                                                                <div
                                                                    className={`avatar-md rounded bg-${card.color}-subtle text-${card.color} d-flex align-items-center justify-content-center`}
                                                                >

                                                                    <i
                                                                        className={`${card.icon} fs-1`}
                                                                    />

                                                                </div>

                                                                <div className="ms-3">

                                                                    <h5>

                                                                        {card.title}

                                                                    </h5>

                                                                    <p className="text-muted mb-0">

                                                                        Download PDF statement

                                                                    </p>

                                                                </div>

                                                            </div>

                                                            <Button
                                                                color={card.color}
                                                                className="w-100 mt-4"
                                                                disabled={loading === card.type}
                                                                onClick={() =>
                                                                    downloadPDF(card.type)
                                                                }
                                                            >

                                                                {

                                                                    loading === card.type ?

                                                                        "Preparing..."

                                                                        :

                                                                        "Download PDF"

                                                                }

                                                            </Button>

                                                        </CardBody>

                                                    </Card>

                                                </Col>

                                            ))

                                        }

                                    </Row>

                                </CardBody>

                            </Card>

                        </Col>

                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );

};

export default StatementDownload;